import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class ExpensesCategorySelectListComponent implements IController {

  options: any;
  selectedId: any;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;

  public excludedMap: any;
  private expensesCategoriesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private active: boolean;

  constructor(private $expensesCategories, private $infiniteScroll, private $log) {
  }

  $onInit() {
    if (!this.options) {
      this.active = true
      this.expensesCategoriesRef = this.$expensesCategories();
      this.loadLimit = 20;

      this.expensesCategoriesRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.expensesCategoriesRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.expensesCategoriesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      active: this.active
    };
  }
}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCategorySelectList', {
    bindings: {
      selectedId: '<',
      options :'<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./expenses-category-select-list.html').default,
    controller: ExpensesCategorySelectListComponent
  });
